/**
 * Workshops Page JavaScript
 * This file handles component loading and interactive elements for the Workshops page
 */

import './workshops.css';

document.addEventListener('DOMContentLoaded', () => {
  // Set current page as active in navigation (with delay to ensure header is loaded)
  setTimeout(setActiveNavItem, 500);
  
  // Initialize workshop page features with a slight delay to ensure DOM is fully loaded
  setTimeout(initWorkshopPage, 500);
  
  // Function to set active navigation items
  function setActiveNavItem() {
    const navItems = document.querySelectorAll('.header__nav-item, .header__mobile-nav-item');
    const currentPath = window.location.pathname;
    
    navItems.forEach(item => {
      const href = item.getAttribute('href');
      if (href && (currentPath === href || currentPath.includes(href) && href !== '/')) {
        item.classList.add('active');
      }
    });
  }
});

// Initialize the workshop page
function initWorkshopPage() {
  // Add subtle animation to the workshop cards
  const cards = document.querySelectorAll('.workshop-card, .format-card');
  cards.forEach((card, index) => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    
    setTimeout(() => {
      card.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      card.style.opacity = '1';
      card.style.transform = 'translateY(0)';
    }, 100 + (index * 100));
  });
  
  // Add pulse animation to highlight values
  const highlightValues = document.querySelectorAll('.highlight-item-value');
  highlightValues.forEach(value => {
    setInterval(() => {
      value.style.transform = 'scale(1.1)';
      setTimeout(() => {
        value.style.transform = 'scale(1)';
      }, 150);
    }, 5000);
  });
  
  // Add interactive effects
  addInteractiveEffects();
}

// Add hover effects to cards and interactive elements
function addInteractiveEffects() {
  // Workshop cards hover effect
  const workshopCards = document.querySelectorAll('.workshop-card');
  workshopCards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.style.transform = 'translateY(-8px)';
    });
    
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
  
  // Format cards hover effect
  const formatCards = document.querySelectorAll('.format-card');
  formatCards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.2)';
      card.style.transform = 'translateY(-6px)';
    });
    
    card.addEventListener('mouseleave', () => {
      card.style.boxShadow = '';
      card.style.transform = '';
    });
  });
  
  // Highlight items hover effect
  const highlightItems = document.querySelectorAll('.highlight-item');
  highlightItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      item.style.backgroundColor = 'rgba(30, 28, 36, 0.9)';
      item.style.transform = 'scale(1.05)';
    });
    
    item.addEventListener('mouseleave', () => {
      item.style.backgroundColor = '';
      item.style.transform = '';
    });
  });
}
